<template>
  <popup class="loading-popup">
    <template v-slot:content>
      <div class="loading-popup-content">
        <div class="spinner-wrapper">
          <spinner/>
        </div>
        <div class="description">
          <div class="title">{{ title }}</div>
          <div class="subtitle">{{ subtitle }}</div>
        </div>
      </div>
    </template>
  </popup>
</template>

<script>
import BaseUI from 'base-ui';
import Spinner from './Spinner.vue';

export default {
  name: 'LoadingPopup',
  components: {
    Popup: BaseUI.Popup,
    Spinner,
  },
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
  .loading-popup {
    width: 100%;

    .loading-popup-content {
      .spinner-wrapper {
        margin: 30px 0 60px;
        width: 100%;
        text-align: center;
      }

      .description {
        width: 100%;
        text-align: center;

        .title {
          line-height: 1.33;
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 10px;
          font-family: SimplerPro;
        }
        .subtitle {
          line-height: 1.33;
          font-size: 18px;
          font-family: SimplerPro;
        }
      }
    }
  }
</style>
